import { connect } from 'react-redux';
import { changeClassesEditOrder,changeInforEditOrder, changeEditOrder } from './../../../../../actions/editOrder';
import ShipmentOptionsComponent from './../../../components/shipment-options';
import './styles.css';

class ShipmentOptions extends ShipmentOptionsComponent { }

const mapStateToProps = state => {
    return {
        classes: state.editOrder.classes,
        information: state.editOrder.information,
        shipperInformation: state.editOrder.shipperInformation,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChangeInformation: payload => {
            dispatch(changeInforEditOrder(payload))
        },
        onChange: payload => {
            dispatch(changeEditOrder(payload))
        },        
        onChangeClasses: payload => {
            dispatch(changeClassesEditOrder(payload))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ShipmentOptions)



// WEBPACK FOOTER //
// ./src/containers/orders/edit/components/shipment-options/index.js